import Swiper, { Navigation, Pagination } from 'swiper'
import gsap from 'gsap'
import { waitUntil, getCookie } from '../utils'

// See .sidePadding in _global.scss
const SIDEPADDING_DESKTOP = 80
const SIDEPADDING_MOBILE = 20
const MOBILE_BREAKPOINT = 900

Swiper.use([Pagination])

class TestimonyCarousel {
  constructor() {
    this.swiper = new Swiper('.testimony .swiper', {
      centeredSlides: true,
      grabCursor: true,
      loop: true,
      slidesPerView: 1.33,
      slideToClickedSlide: true,
      spaceBetween: 24,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        [MOBILE_BREAKPOINT]: {
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 1.66,
          spaceBetween: 40,
        },
        1440: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        2000: {
          slidesPerView: 2.33,
          spaceBetween: 40,
        },
      },
    })

    document.querySelectorAll('.slide-cover').forEach((el) => {
      // stop propogation to allow click on slide
      el.addEventListener('touchstart click', (e) => {
        e.stopPropagation()
      })
    })
  }
}

class LogoCarousel {
  constructor() {
    this.swiper = new Swiper('.logo-quilt .swiper', {
      slidesPerView: 2,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        [MOBILE_BREAKPOINT]: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    })
  }
}

class ResourceCarousel {
  constructor() {
    const resourcesSwiper = new Swiper('.resources .swiper', {
      slidesPerView: 1.33,
      spaceBetween: 24,
      slidesOffsetBefore: SIDEPADDING_MOBILE,
      slidesOffsetAfter: SIDEPADDING_MOBILE,
      initialSlide: 0,
      breakpoints: {
        [MOBILE_BREAKPOINT]: {
          slidesPerView: 2.33,
          slidesOffsetBefore: SIDEPADDING_DESKTOP,
          slidesOffsetAfter: SIDEPADDING_DESKTOP,
        },
        1200: {
          slidesPerView: 3,
          centeredSlides: true,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          initialSlide: 1,
        },
      },
    })
  }
}

export class HomeV2 {
  constructor() {
    new LogoCarousel()
    new TestimonyCarousel()
    new ResourceCarousel()
  }
}

class Home {
  constructor() {
    if (document.querySelector('#homePage')) {
      this.Home()
    }
  }

  async Home() {
    this.onProfile = 'business'
    document.body.classList.add('business')
    window.location.hash === '#agents' && this.switchProfile('agents')

    document.querySelectorAll('.homeHow__btn').forEach((el) => {
      el.addEventListener('click', () => {
        this.switchProfile(el.dataset.target)
      })
    })

    Swiper.use([Navigation])
    new Swiper('.homeInsights__swiper', {
      navigation: {
        nextEl: '.homeInsights__next',
        prevEl: '.homeInsights__prev',
      },
      slidesPerView: 1.2,
      spaceBetween: 20,
      breakpoints: {
        763: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    })

    window.addEventListener('resize', this.resized)
    this.resized()
    setTimeout(() => {
      this.resized()
    }, 750)
  }

  switchProfile(profile) {
    if (this.onProfile == profile) return

    // -- Profiles
    document.querySelector('.homeProfiles').classList.remove(this.onProfile)
    document.querySelector('.homeProfiles').classList.add(profile)

    document.querySelector(`.homeProfile--${this.onProfile}`).style.opacity = 0
    document.querySelector(`.homeProfile--${this.onProfile}`).style.display =
      'none'

    gsap.to(document.querySelector(`.homeProfile--${profile}`), {
      alpha: 1,
      duration: 0.45,
      ease: 'circ.out',
    })
    document.querySelector(`.homeProfile--${profile}`).style.display = 'block'

    // -- Why

    const whyElementOld = document.querySelector(
      `.homeProfilesWhy--${this.onProfile}`
    )

    if (whyElementOld) {
      whyElementOld.style.opacity = 0
      whyElementOld.style.display = 'none'
    }

    const whyElementNew = document.querySelector(`.homeProfilesWhy--${profile}`)

    if (whyElementNew) {
      gsap.to(whyElementNew, {
        alpha: 1,
        duration: 0.45,
        ease: 'circ.out',
      })
      whyElementNew.style.display = 'block'
    }

    // -- Quotes
    document.querySelector(
      `.homeProfilesQuote--${this.onProfile}`
    ).style.opacity = 0
    document.querySelector(
      `.homeProfilesQuote--${this.onProfile}`
    ).style.display = 'none'

    gsap.to(document.querySelector(`.homeProfilesQuote--${profile}`), {
      alpha: 1,
      duration: 0.45,
      ease: 'circ.out',
    })
    document.querySelector(`.homeProfilesQuote--${profile}`).style.display =
      'block'

    // -- Benefits
    const benefitsElementOld = document.querySelector(
      `.homeProfilesBenefits--${this.onProfile}`
    )
    if (benefitsElementOld) {
      benefitsElementOld.style.opacity = 0
      benefitsElementOld.style.display = 'none'
    }

    const benefitsElementNew = document.querySelector(
      `.homeProfilesBenefits--${profile}`
    )

    if (benefitsElementNew) {
      gsap.to(benefitsElementNew, {
        alpha: 1,
        duration: 0.45,
        ease: 'circ.out',
      })
      benefitsElementNew.style.display = 'block'
    }

    // -- Btns
    document
      .querySelector(`.homeHow__btn--${this.onProfile}`)
      .classList.remove('selected')
    document
      .querySelector(`.homeHow__btn--${profile}`)
      .classList.add('selected')

    // -- Footer
    document.body.classList.add(profile)
    document.body.classList.remove(this.onProfile)

    this.onProfile = profile
    setTimeout(() => {
      this.resized()
    }, 750)
  }

  resized() {
    let h = document.querySelector('.homeProfilesBottom').clientHeight
    let benH
    if (document.querySelector('.homeProfiles').classList.contains('agents')) {
      benH = document.querySelector(
        '.homeProfilesBenefits--agents'
      ).clientHeight
    } else if (
      document.querySelector('.homeProfiles').classList.contains('thirdProfile')
    ) {
      benH = document.querySelector(
        '.homeProfilesBenefits--thirdProfile'
      ).clientHeight
    } else {
      benH = 0
    }
    h = h - benH * 0.4

    document.querySelector('.homeProfilesBottom__mask').style.height = `${h}px`
  }
}

export default Home
